export const RoleScoreMap = {
    enterprise: 100,
    myCustomer: 90,
    myClue: 80,
    colleagueCustomer: 70,
    colleagueCustomerNoAuth: 65,
    colleagueClue: 60,
    colleagueClueNoAuth: 55,
    openSeaCustomer: 50,
    openSeaClue: 40,
    personal: 30,
    external: 20,
};
export const edmMailHelper = {
    getCustomerInfo(mailModel) {
        var _a;
        return (_a = mailModel === null || mailModel === void 0 ? void 0 : mailModel.sender) === null || _a === void 0 ? void 0 : _a.contact.customerOrgModel;
    },
    filterEdmFid(fid) {
        return fid > 0 && ![2, 4].includes(fid);
    },
    isEdmMailReq(checkType = '') {
        return ['checkCustomerMail', 'checkSubordinateMail'].includes(checkType);
    },
    transContactModelToEmailRole(contact, accountNameOrDisplayEmail) {
        let email = contact.displayEmail || contact.accountName;
        if (accountNameOrDisplayEmail) {
            email = accountNameOrDisplayEmail === contact.accountName ? contact.accountName : email;
        }
        return {
            role: contact.type,
            email,
            companyId: '',
            companyName: '',
            contactId: contact.id,
            contactName: contact.contactName,
            contactAvatar: contact.avatar,
            relatedCompanyInfo: [],
        };
    },
    compareRoles(prev, next, viewPrivilege) {
        const prevScore = edmMailHelper.getRoleScoreByViewPrivilege(prev.role, viewPrivilege) || 0;
        const nextScore = edmMailHelper.getRoleScoreByViewPrivilege(next.role, viewPrivilege) || 0;
        if (prevScore > nextScore) {
            return 1;
        }
        if (prevScore < nextScore) {
            return -1;
        }
        const prevCreateTime = prev.customerCreateTime || 0;
        const nextCreateTime = next.customerCreateTime || 0;
        if (prevCreateTime > nextCreateTime) {
            return 1;
        }
        if (prevCreateTime < nextCreateTime) {
            return -1;
        }
        const prevContactId = +prev.contactId;
        const nextContactId = +next.contactId;
        if (prevContactId > nextContactId) {
            return 1;
        }
        if (prevContactId < nextContactId) {
            return -1;
        }
        return 0;
    },
    getRoleScoreByViewPrivilege(role, viewPrivilege) {
        const originScore = RoleScoreMap[role] || 0;
        if (!viewPrivilege) {
            return originScore;
        }
        if (role === 'myCustomer' || role === 'colleagueCustomer') {
            return viewPrivilege.customer ? originScore : -1000;
        }
        if (role === 'openSeaCustomer') {
            return viewPrivilege.openSeaCustomer ? originScore : -1000;
        }
        if (role === 'myClue' || role === 'colleagueClue') {
            return viewPrivilege.clue ? originScore : -1000;
        }
        if (role === 'openSeaClue') {
            return viewPrivilege.openSeaClue ? originScore : -1000;
        }
        return originScore;
    },
    insertIntoDataMap(params) {
        const { dataMap, newData, emailSet, maxScore = 0, privilege } = params;
        const { email, role } = newData;
        const existData = dataMap.get(email);
        const score = edmMailHelper.getRoleScoreByViewPrivilege(role, privilege);
        if (score < 0) {
            return;
        }
        const replaceOrInsert = !existData || existData.score < score || (existData.score === score && +existData.data.contactId < +newData.contactId);
        const toPushIntoRelatedInfo = existData && existData.score === score && existData.data.companyId !== newData.companyId;
        if (replaceOrInsert && !toPushIntoRelatedInfo) {
            dataMap.delete(email);
            dataMap.set(email, { score, data: newData });
            if (score === maxScore) {
                emailSet.delete(email);
            }
        }
        else if (toPushIntoRelatedInfo) {
            const existCreateTime = existData.data.customerCreateTime || 0;
            const newCreateTime = newData.customerCreateTime || 0;
            let relatedCustomer;
            if (existCreateTime >= newCreateTime) {
                relatedCustomer = { companyId: String(newData.companyId), companyName: String(newData.companyName || ''), leadsName: String(newData.leadsName || '') };
            }
            else {
                existData.data = Object.assign(Object.assign({}, newData), { relatedCompanyInfo: existData.data.relatedCompanyInfo });
                relatedCustomer = {
                    companyId: String(existData.data.companyId),
                    companyName: String(existData.data.companyName || ''),
                    leadsName: String(existData.data.leadsName || ''),
                };
            }
            const tempSet = new Set(existData.data.relatedCompanyInfo.map(v => v.companyId));
            if (!tempSet.has(relatedCustomer.companyId)) {
                existData.data.relatedCompanyInfo.push(relatedCustomer);
                tempSet.add(relatedCustomer.companyId);
            }
            if (!tempSet.has(existData.data.companyId)) {
                existData.data.relatedCompanyInfo.push({
                    companyId: String(existData.data.companyId),
                    companyName: String(existData.data.companyName || ''),
                    leadsName: String(existData.data.leadsName || ''),
                });
            }
        }
    },
    getMyCustomerByEmailList: (res, emailList) => {
        const idSet = emailList
            .filter(email => {
            const item = res[email];
            return (item === null || item === void 0 ? void 0 : item.role) === 'myCustomer' && item.companyId;
        })
            .reduce((total, email) => {
            const current = res[email];
            total.add(current.companyId);
            if (Array.isArray(current.relatedCompanyInfo)) {
                current.relatedCompanyInfo.forEach(v => {
                    total.add(v.companyId);
                });
            }
            return total;
        }, new Set());
        return [...idSet];
    },
};
